import { render, staticRenderFns } from "./HeadModalStu.vue?vue&type=template&id=3eb0051e&scoped=true&"
import script from "./HeadModalStu.vue?vue&type=script&lang=js&"
export * from "./HeadModalStu.vue?vue&type=script&lang=js&"
import style0 from "./HeadModalStu.vue?vue&type=style&index=0&id=3eb0051e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb0051e",
  null
  
)

export default component.exports